import ObjectParser from "./parser/ObjectParser";
import ValueChecker from "./ValueChecker";

export default {
    eventStorage: {},
    emitEvents(eventsConfig, eventBus, supportedEvents, data, routeName) {
        Object.entries(eventsConfig || {}).forEach(entry => {
            let [eventName, value] = entry;

            if (!supportedEvents.includes(eventName)) {
                return;
            }

            value.forEach(eventConfig => {
                switch (eventConfig.type) {
                    case 'backend':
                        let params = ObjectParser.parse(eventConfig.config.data, data);
                        let url = routeName + eventConfig.config.url
                        eventBus.$http[eventConfig.config.method](url, params).then(response => {
                            this.emitEvents(eventConfig.config.emitEvents, eventBus, 'callbacks', data, routeName)
                        });
                        break;
                    case 'frontend':
                        eventBus.$emit(eventConfig.config.name, eventConfig.config.componentIndex);
                        break;
                }
            });
        });
    },
    bind(eventsConfig, eventBus, component, componentIndex) {
        Object.entries(eventsConfig || {}).forEach(entry => {
            let [eventName, value] = entry;
            let eventHashName = eventName + '_' + componentIndex;

            if (this.checkExistsInStorage(eventHashName)) {
                return;
            }

            value.forEach(eventConfig => {
                if (!ValueChecker.isFunction(component[eventConfig.name])) {
                    throw `Method not exists "${eventConfig.name}"`;
                }

                if (eventConfig.componentIndex === componentIndex) {
                    eventBus.$on(eventName, component[eventConfig.name]);
                    this.addToStorage(eventHashName);
                }
            });
        });
    },
    addToStorage(name) {
        this.eventStorage[name] = true;
    },
    checkExistsInStorage(name) {
        return this.eventStorage[name];
    },
}



// WEBPACK FOOTER //
// ./src/services/EventManager.js